import React, { FunctionComponent } from 'react';
import { Button } from '@mui/material';

interface Props {
  text: string;
  variant?: any;
  width?: string;
  height?: string;
  background: string;
  color?: string;
  onClick?: () => void;
}

export const MyButton: FunctionComponent<Props> = ({
  text,
  width,
  variant,
  height,
  background,
  color,
  onClick,
}) => (
  <Button
    onClick={onClick}
    variant={variant}
    sx={{
      background,
      ':hover': {
        background,
      },
      ':focus': {
        background,
      },
    }}
    style={{
      fontFamily: 'SF Compact Display',
      fontSize: '16px',
      textTransform: 'none',
      width,
      height,
      color,
    }}
  >
    {text}
  </Button>
);

MyButton.defaultProps = {
  width: '100%',
  height: '50px',
  variant: 'contained',
  color: '#FFFFFF',
  onClick: () => undefined,
};
